<template>
  <div class="root">
    <div class="picture">
      <img
        src="../../../shared/assets/images/switch.png"
        alt="icon"
        width="220px"
        height="220px"
      />
    </div>

    <div class="header">{{ $t('SubAccountModal | title') }}</div>

    <div class="description">
      {{ $t('SubAccountModal | description') }}
    </div>

    <div class="actions">
      <base-button type="cta" size="lg" @onClick="showWithdrawModal">
        {{ $t('SubAccountModal | actionWithdrawToWallet') }}
      </base-button>
      <base-button
        type="shade"
        size="lg"
        :disabled="isLoadingSubAccountsList"
        @onClick="switchToMainAccount"
      >
        {{
          $t('SubAccountModal | actionChangeToMainAccount', {
            mainaccount: username,
          })
        }}
      </base-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import BaseButton from '@/shared/ui/BaseButton/BaseButton.vue'

export default {
  name: 'SwitchToMainAccountModal',
  components: { BaseButton },

  props: {
    coinId: {
      type: String,
    },
  },
  emits: ['close', 'open'],

  data() {
    return {
      modalName: 'WithdrawToCard',
      isLoadingSubAccountsList: true,
    }
  },

  computed: {
    ...mapState('auth', ['user']),

    username() {
      return this.user?.username
    },
  },

  methods: {
    ...mapActions('auth', ['switchSubAccount', 'loadAccountList']),

    async switchToMainAccount() {
      const mainUser = { id: this.user?.user_id }
      this.switchSubAccount(mainUser)
      this.$emit('close')
    },

    // Open modal with withdraw to wallet operation
    async showWithdrawModal() {
      this.$emit('open', 'WithdrawToWallet', {
        coin: this.coinId || 'btc',
        isButtonDirect: false,
      })
    },
  },

  async mounted() {
    this.isLoadingSubAccountsList = true
    await this.loadAccountList(this.$apiService().endpointApi)
    this.isLoadingSubAccountsList = false
  },
}
</script>

<style scoped lang="scss">
.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--text-1);
  line-height: 1.2;
  word-break: break-word;
}

.picture {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 36px;
  border-radius: 100%;
}

.header {
  margin-top: 50px;
  width: 360px;
  display: flex;
  justify-content: center;
  text-align: center;
  font-weight: 700;
  font-size: 1.725rem; /* 28px */
  line-height: 130%; /* 36.4px */
}

.description {
  margin-top: 20px;
  width: 380px;
  color: var(--text-2);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
}

.actions {
  margin-top: 40px;
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
</style>
